import { LOCATION_CHANGE } from '../../../../../shared/frontend/libs/router/redux-store';
import {
  SET_KEYSTONE_TEAM_DETAILS,
  SET_PENDING_SEASON,
  SET_TEAM_MYTHIC_PLUS_FILTERS,
  SHOW_LOADING_SPINNER,
  TOGGLE_OPEN_DUNGEON
} from '../actions/keystoneTeamDetailsActionCreator';
import { TAction } from '../../../../../shared/frontend/scripts/actions/types/action';
import { TKeystoneTeamDetailsClientState } from '../libs/store';

const roleSorts: any = {
  tank: 1,
  healer: 2,
  dps: 3
};

function ordinalForRole(role: string): number {
  if (!role) {
    return 999;
  }
  const roleCheck = role.toLowerCase();
  return roleSorts[roleCheck] || 999;
}

function sortRoster(a: any, b: any) {
  const aRoleOrder = ordinalForRole(a.role);
  const bRoleOrder = ordinalForRole(b.role);
  if (aRoleOrder === bRoleOrder) {
    if (b.character.name === a.character.name) {
      return 0;
    } else if (a.character.name < b.character.name) {
      return -1;
    } else {
      return 1;
    }
  } else {
    return aRoleOrder - bRoleOrder;
  }
}

export default function keystoneTeamDetails(
  state: Partial<TKeystoneTeamDetailsClientState> = {},
  action: TAction<any>
): Partial<TKeystoneTeamDetailsClientState> {
  switch (action.type) {
    case SET_KEYSTONE_TEAM_DETAILS: {
      action.payload.details.team.members.sort(sortRoster); // FIXME: should not mutate the payload
      return {
        openDungeons: {},
        ...state,
        season: action.payload.details.ui.season, // FIXME: was currentSeasonSlug
        ...action.payload.details,
        instances: {
          ...state.instances,
          [action.payload.instanceId]: action.payload.details
        }
      };
    }
    case SET_PENDING_SEASON: {
      return {
        ...state,
        pendingSeason: action.payload
      };
    }
    case SET_TEAM_MYTHIC_PLUS_FILTERS: {
      return {
        ...state,
        filters: {
          ...(state.filters || {
            mode: 'scored'
          }),
          ...action.payload
        },
        openDungeons: {}
      };
    }
    case SHOW_LOADING_SPINNER: {
      return {
        ...state,
        isLoading: action.payload
      };
    }
    case TOGGLE_OPEN_DUNGEON: {
      return {
        ...state,
        openDungeons: {
          ...(state.openDungeons || {}),
          [action.payload]: state.openDungeons ? !state.openDungeons[action.payload] : true
        }
      };
    }
    case LOCATION_CHANGE: {
      if (action.payload.isFirstRendering) {
        return state; // server render may have pre-populated state, so we don't want to nuke it
      }
      return {};
    }
    default: {
      return state;
    }
  }
}
